import request from "@/utils/request";
import {
  loginModel,
  UserInfo,
  QueryShoninsha,
  ShoninshaModel,
  ShinseishaModel,
  QueryShinseisha,
  updateUserProfileModel,
  SetPasswordModel,
  VerifySetPasswordPage,
} from "@/interfaces/account.interface";
import { ApiResult } from "@/interfaces/api.interface";
import { AxiosPromise } from "axios";
import { CheckExist } from "@/interfaces/common.interface";

export function login(user: loginModel): AxiosPromise<ApiResult<string>> {
  return request({
    url: "account/login",
    method: "post",
    data: user,
  });
}

export function getUerInfo(token: string): AxiosPromise<ApiResult<UserInfo>> {
  return request({
    url: `account/info/${token}`,
    method: "get",
  });
}

export function getUserProfile(): AxiosPromise<ApiResult<any>> {
  return request({
    url: `account/profile`,
    method: "get",
  });
}

export function updateUserProfile(
  accountId: string,
  data: updateUserProfileModel
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `account/updateProfile/${accountId}`,
    method: "patch",
    data,
  });
}

//passwordリセット用signed urlを会員様にを送信
export function resetPassword(email: string): AxiosPromise<ApiResult<string>> {
  return request({
    url: `account/resetPassword/${email}`,
    method: "get",
  });
}
//パスワード設定
export function setPassword(
  params: SetPasswordModel
): AxiosPromise<ApiResult<string>> {
  return request({
    url: "account/setPassword",
    method: "post",
    data: params,
  });
}
//会員様がパスワード設定画面にアクセス権限あるか判断
export function checkPasswordSettingPage(
  params: VerifySetPasswordPage
): AxiosPromise<ApiResult<string>> {
  return request({
    url: `account/checkPasswordSettingPage`,
    method: "get",
    params,
  });
}

// 承認者関連
export function getShoninshaList(
  params: QueryShoninsha
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninsha/getList`,
    params,
    method: "get",
  });
}

export function getShoninshaById(id: string): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninsha/getById/${id}`,
    method: "get",
  });
}

export function deleteShoninsha(
  accountId: string
): AxiosPromise<ApiResult<undefined>> {
  return request({
    url: `shoninsha/delete/${accountId}`,
    method: "delete",
  });
}

export function checkShoninsha(
  params: CheckExist
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninsha/checkExist`,
    method: "get",
    params,
  });
}

export function checkAccount(params: CheckExist): AxiosPromise<ApiResult<any>> {
  return request({
    url: `account/checkExist`,
    method: "get",
    params,
  });
}

type ShoninshaData = Omit<ShoninshaModel, "accountId">;
export function addShoninsha(
  data: ShoninshaData
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninsha/create`,
    method: "post",
    data,
  });
}

export function updateShoninsha(
  id: string,
  data: ShoninshaData
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shoninsha/update/${id}`,
    method: "patch",
    data,
  });
}

// 申請者関連
export function getShinseishaList(
  params: QueryShinseisha
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseisha/getList`,
    params,
    method: "get",
  });
}

export function getShinseishaById(id: string): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseisha/getById/${id}`,
    method: "get",
  });
}

type ShinseishaData = Omit<
  ShinseishaModel,
  "accountId" | "kaishaCd" | "kaishaNm" | "groupNm"
>;
export function createShinseishaIppan(
  data: ShinseishaData
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseisha/createIppan`,
    method: "post",
    data,
  });
}

export function createShinseishaKanri(
  data: ShinseishaData
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseisha/createKanri`,
    method: "post",
    data,
  });
}

export function updateShinseishaIppan(
  id: string,
  data: ShinseishaData
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseisha/updateIppan/${id}`,
    method: "patch",
    data,
  });
}

export function updateShinseishaKanri(
  id: string,
  data: ShinseishaData
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `shinseisha/updateKanri/${id}`,
    method: "patch",
    data,
  });
}

export function deleteShinseishaIppan(
  accountId: string
): AxiosPromise<ApiResult<undefined>> {
  return request({
    url: `shinseisha/deleteIppan/${accountId}`,
    method: "delete",
  });
}

export function deleteShinseishaKanri(
  accountId: string
): AxiosPromise<ApiResult<undefined>> {
  return request({
    url: `shinseisha/deleteKanri/${accountId}`,
    method: "delete",
  });
}
